import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import 'lib-flexible';
import 'vant/lib/index.css';
import '@/utils/css/reset.css';
import '@/utils/css/comment.css';


//util.js
import util from "@/utils/js/util.js"
Vue.prototype.$util = util;

//加密
import JsEncrypt from 'jsencrypt'
Vue.prototype.$jsEncrypt = JsEncrypt;

// import md5 from 'js-md5';
// Vue.prototype.$md5 = md5;

// http服务
import createRequestHttp from '@/utils/js/http';
Vue.prototype.$http = createRequestHttp;

// vantUI
import Vant from 'vant';
Vue.use(Vant);

// 路由title
import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle)

//视频
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
//全局导航
import tabbar from '@/components/tabbar/tabbar.vue'
Vue.component('tabbar', tabbar);

Vue.config.productionTip = false;

var vue = new Vue({
  router: router,
  store: store,
  render: h => h(App)
}).$mount('#app')
